// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageContext';
import SiteHeader from './components/layout/SiteHeader';
import SiteFooter from './components/layout/SiteFooter';
import MobileActionBar from './components/layout/MobileActionBar';
import ScrollToTop from './components/ScrollToTop';
import { CompareProvider } from './context/CompareContext';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import InvestmentsPage from './pages/InvestmentsPage';
import GalleryPage from './pages/GalleryPage';
import ContactPage from './pages/ContactPage';
import PaymentPage from './pages/PaymentPage';
import MutualFundDashboard from './pages/MutualFundDashboard';
import FundDetailPage from './pages/FundDetailPage';
import ComparePage from './pages/ComparePage';
import CalculatorsPage from './pages/CalculatorsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsConditionsPage from './pages/TermsConditionsPage';
import DataDeletionPage from './pages/DataDeletionPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <ScrollToTop />
        <CompareProvider>
          <SiteHeader />
          <main className="min-h-screen pb-16 md:pb-0">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
              <Route path="/investments" element={<InvestmentsPage />} />
              <Route path="/mutual-funds" element={<MutualFundDashboard />} />
              <Route path="/mutual-funds/:schemeCode" element={<FundDetailPage />} />
              <Route path="/compare" element={<ComparePage />} />
              <Route path="/calculators" element={<CalculatorsPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/why-choose-us" element={<AboutPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/pay-premium" element={<PaymentPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms-and-conditions" element={<TermsConditionsPage />} />
              <Route path="/data-deletion" element={<DataDeletionPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
          <SiteFooter />
          <MobileActionBar />
        </CompareProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
